import EqualHeights from "./EqualHeights";

setTimeout(() => {
	new EqualHeights();
}, 500);